import { render, staticRenderFns } from "./clientList-mobile.vue?vue&type=template&id=3134c806"
import script from "./clientList-mobile.vue?vue&type=script&lang=js"
export * from "./clientList-mobile.vue?vue&type=script&lang=js"
import style0 from "./clientList-mobile.vue?vue&type=style&index=0&id=3134c806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports